class JobsList {
  constructor(el) {
    this.el = el;
    this.btnLoadMore = this.el.querySelector('[data-action-load-more]');
    this.list = this.el.querySelector('[data-list-jobs-items]');
    this.currentPage = 1;
    this.init();
  }

  init() {
    if (!this.btnLoadMore) {
      return;
    }

    this.btnLoadMore.addEventListener('click', (event) => {
      event.preventDefault();
      this.fetchJobs();
    });
  }

  fetchJobs() {
    this.currentPage++;
    const nonce = document.querySelector('[name="csrf-token"]').content;

    const data = {
      page: parseInt(this.currentPage),
      action: 'jobs_load_more',
      nonce,
    };
    fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({ ...data }),
    })
      .then((response) => response.json())
      .then((data) => {
        const divEl = document.createElement('div');
        divEl.innerHTML = data.posts_html;
        divEl.childNodes.forEach((child) => {
          this.list.appendChild(child);
        });
        if (data.max_page === this.currentPage) {
          this.btnLoadMore.style.display = 'none';
        }
      });
  }
}

export default JobsList;
